import React, { createContext, useContext, useEffect, useState } from 'react';
import { initialize } from 'launchdarkly-js-client-sdk';
import { LDConfig } from 'utils/launchDarklyConfig';

interface LaunchDarklyContextData {
  isReady: boolean;
  flags: {
    preRegister: boolean;
    firstAccess: boolean;
    tangieConfirmCobranded: boolean;
  };
}

const LaunchDarklyContext = createContext<LaunchDarklyContextData>({} as LaunchDarklyContextData);

export const useLDVariants = () => useContext(LaunchDarklyContext);

export const LaunchDarklyProvider: React.FC = ({ children }) => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const [preRegister, setPreRegister] = useState<boolean>(false);
  const [firstAccess, setFirstAccess] = useState<boolean>(false);
  const [tangieConfirmCobranded, setTangieConfirmCobranded] = useState<boolean>(false);

  async function Initialize() {
    const clientKey = await LDConfig.GetCurrentEnvironment();
    const relayUrl = await LDConfig.GetRelayBaseUrl();

    let user = { key: window.location.origin };

    if (window.location.hostname === 'localhost') {
      user = { key: 'https://portal-uat5.smiles.com.br' };
    }

    const ldclient = initialize(clientKey, user, {
      baseUrl: relayUrl,
      eventsUrl: relayUrl,
      streamUrl: relayUrl,
    });

    ldclient.on('ready', () => {
      const preRegisterVariation = ldclient.variation('boo-front-preregister', true);
      const firstAccessVariation = ldclient.variation('boo-front-firstlogin', false);
      const tangieConfirmCobrandedVariation = ldclient.variation('boo-front-tangie-confirm-cobranded', false);

      setPreRegister(preRegisterVariation);
      setFirstAccess(firstAccessVariation);
      setTangieConfirmCobranded(tangieConfirmCobrandedVariation);

      setIsReady(true);
    });
  }
  useEffect(() => {
    Initialize();
  }, []);

  const flags = {
    preRegister,
    firstAccess,
    tangieConfirmCobranded,
  };

  return isReady ? (
    <LaunchDarklyContext.Provider value={{ isReady, flags }}>{children}</LaunchDarklyContext.Provider>
  ) : (
    <></>
  );
};
